import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";

type XpEvent = { id: string; amount: number; x: number; y: number };

let listeners: ((event: XpEvent) => void)[] = [];

export function emitXpPopup(amount: number, x: number, y: number) {
  const event = { id: crypto.randomUUID(), amount, x, y };
  listeners.forEach((l) => l(event));
}

export function XpPopupLayer() {
  const [events, setEvents] = useState<XpEvent[]>([]);

  useEffect(() => {
    const handler = (e: XpEvent) => {
      setEvents((prev) => [...prev, e]);
      setTimeout(() => {
        setEvents((prev) => prev.filter((p) => p.id !== e.id));
      }, 1200);
    };
    listeners.push(handler);
    return () => {
      listeners = listeners.filter((l) => l !== handler);
    };
  }, []);

  return createPortal(
    <div className="fixed inset-0 pointer-events-none z-[9999]">
      <AnimatePresence>
        {events.map((e) => (
          <motion.div
            key={e.id}
            initial={{ opacity: 1, y: 0 }}
            animate={{ opacity: 0, y: -60 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="absolute text-sm font-bold text-primary drop-shadow-[0_0_6px_hsl(var(--primary)/0.4)]"
            style={{ left: e.x, top: e.y }}
          >
            +{e.amount} XP
          </motion.div>
        ))}
      </AnimatePresence>
    </div>,
    document.body
  );
}
